<template>
  <ul class="card link-list">
    <li
      v-if="canBeRebooked"
      class="link-list__item"
    >
      <router-link
        class="link-list__link edit-booking-links__link--top"
        :to="{
          name: 'AfterSaleRebook',
          params: { bookingNumber: bookingNumber },
        }"
      >
        <span>
          <svg class="link-list__icon-link">
            <use :xlink:href="`#${edit}`" />
          </svg>
          {{ $t('afterSale.actions.rebook') }}
        </span>
        <svg class="link-list__chevron">
          <use :xlink:href="`#${chevron}`" />
        </svg>
      </router-link>
    </li>
    <!-- <li v-if="canChangeName" class="link-list__item">
      <router-link
        class="link-list__link"
        to="/home"
      >
        <span>
          <svg class="link-list__icon-link">
            <use :xlink:href="`#${person}`" />
          </svg>
          {{ $t('afterSale.actions.changeOwner') }}
        </span>
        <svg class="link-list__chevron">
          <use :xlink:href="`#${chevron}`" />
        </svg>
      </router-link>
    </li> -->
    <!-- <li class="link-list__item">
      <router-link
        class="link-list__link"
        to="/home"
      >
        <span>
          <svg class="link-list__icon-link">
            <use :xlink:href="`#${receipt}`" />
          </svg>
          {{ $t('afterSale.actions.viewReceipt') }}
        </span>
        <svg class="link-list__chevron">
          <use :xlink:href="`#${chevron}`" />
        </svg>
      </router-link>
    </li> -->
    <li
      v-if="canBeCancelled"
      class="link-list__item"
    >
      <router-link
        class="link-list__link"
        :to="{
          name: 'AfterSaleCancel',
          params: { bookingNumber: bookingNumber },
        }"
      >
        <span>
          <svg class="link-list__icon-link">
            <use :xlink:href="`#${cancelTicket}`" />
          </svg>
          {{ $t('afterSale.actions.cancel') }}
        </span>
        <svg class="link-list__chevron">
          <use :xlink:href="`#${chevron}`" />
        </svg>
      </router-link>
    </li>
  </ul>
</template>

<script lang="ts">
  import { defineComponent, PropType, computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useBookingStore } from '@/stores/bookingStore'
  import edit from '@/assets/icons/edit.svg'
  import receipt from '@/assets/icons/receipt.svg'
  import cancelTicket from '@/assets/icons/cancelTicket.svg'
  import chevron from '@/assets/icons/chevron.svg'
  import person from '@/assets/icons/person.svg'

  export default defineComponent({
    name: 'EditBookingLinks',
    props: {
      canBeRebooked: {
        type: Boolean,
        required: true,
      },
      canBeCancelled: {
        type: Boolean,
        required: true,
      },
      canChangeName: {
        type: Boolean,
        required: true,
      },
      bookingNumber: {
        type: String,
        required: true,
      },
    },
    setup(props) {
      const { t } = useI18n()
      const bookingStore = useBookingStore()

      return {
        edit,
        receipt,
        cancelTicket,
        chevron,
        person,
        t,
        bookingNumber: props.bookingNumber,
      }
    },
  })
</script>
